export function loadExternalResources() {
  return new Promise<void>((resolve, reject) => {
    const ts = Date.now();
    const isLocalhost = location.hostname.match('localhost') || location.hostname.match('192.168');
    const base = isLocalhost ? 'https://test-huiben.yunzhan365.com' : '';

    const link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = base + '/components/min/main.css?v=' + ts;
    document.head.appendChild(link);

    const mainScript = document.createElement('script');
    mainScript.type = 'text/javascript';
    mainScript.src = base + '/components/min/main.js?v=' + ts;
    mainScript.onload = () => resolve();
    mainScript.onerror = () => reject(new Error('Failed to load main.js'));
    document.head.appendChild(mainScript);
  });
}
